<template>
    <div style="width: 100%;position: absolute;bottom: 0;top: 0;background-repeat: no-repeat;background-size: cover" >
        <nav-bar></nav-bar>

        <div class="content">

            <van-button type="primary" size="large" @click="onPay(1)">微信支付</van-button>
            <div class="border-btn" @click="onPay(2)">支付宝支付</div>
        </div>

    </div>
</template>

<script>
    import NavBar from '@/components/NavBar'
    export default {
        name: "Pay",
        components: {

            NavBar
        },

        data(){

            return {

                orderNo:'', //'201912062310556446',
                id:1,

            }

        },

        created(){

           this.orderNo = this.$route.query.orderNo;

           this.id = this.$route.query.id;


        },

        methods:{


            onPay(idx){


                if(!this.orderNo){

                    this.$toast('获取订单号异常')

                    return;
                }

                //微信支付
                if(idx===1){
                      location.href = this.$http.baseUrl + '/GZFPOneMeters/WXPay?OrderNo=' + this.orderNo + '&WxReturnUrl=https://act.gzxczx.org.cn/pay/&AppKey=c0ee26b6-40fb-422e-9847-6acb6cd6e936&trapType=2'

                //支付宝支付
                }else {

                    location.href = this.$http.baseUrl + '/GZFPOneMeters/AliPay?OrderNo=' + this.orderNo + '&AppKey=c0ee26b6-40fb-422e-9847-6acb6cd6e936'

                }

            }




        }
    }
</script>

<style scoped>


    .content{

        padding-top: 100px;
        text-align: center;
        margin-left: 20px;
        margin-right: 20px;


    }

    .van-button--primary {
        color: #fff;
        background-color: #07c160;

    }

    .border-btn{


        margin-top: 20px;
        background-color: #108ee9;
        text-align: center;
        line-height: 48px;
        border-radius: 2px;
        color: #fff;

    }

</style>
